module.exports = __webpack_public_path__ + "img/bg3.27aa6a73.png";